import React ,{useEffect} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import defaultStyles from './viewDailyFiles.module.scss';
import {dailyFileConnected, refreshDailyFiles, setGridSorts} from '../actions'
import GridHeader from '../../common/gridheader/GridHeader';
import Grid from '../../webcommon/grid/Grid';
import {dailyFileColumns} from '../constants';
import { getTimeStamp } from '../../webcommon/common/helpers';
import * as selectors from '../selectors'
import {getDefaultSort} from '../selectors'
import { findGridSort } from "../../common/helpermethods/HelperMethods"

const ViewDailyFiles = (props)=> {

    const {
        dailyFileConnected,
        location        
    } = props;            

    useEffect(() => {
        dailyFileConnected(location.search);
    },[dailyFileConnected, location]);

    
    return (
        <div className={props.styles.wrapper}>
            <div className={props.styles.filter}>                                                               
                <div>
                        <div className={props.styles.gridHeader}>
                            <GridHeader
                                title="Daily Files Available"   
                                refreshControlsActive
                                refreshData={ props.refreshDailyFiles }   
                                lastUpdated={ props.lastUpdated }                                                 
                            >
                                </GridHeader>                    
                        </div>
                        <div className={props.styles.grid}>
                            <Grid
                                sortable
                                columns={dailyFileColumns}
                                rows={props.rowsDailyFiles}
                                loading={ props.loading }
                                defaultSorted={ findGridSort(props.defaultSort,
                                    'timestampSort') }
                                onSortedChange={ (newSorted) => {
                                        props.setGridSorts('timestampSort', newSorted);
                                    } }
                                
                    />
                        </div>
                    </div>
                               
            </div>      
        </div>       
        ); 
}
ViewDailyFiles.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    dailyFileConnected: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)    
};

ViewDailyFiles.defaultProps = {
     styles: defaultStyles,
     dateProp: '',
     lastUpdated: getTimeStamp(),
};

const mapDispatchToProps = {
    dailyFileConnected,
    refreshDailyFiles,
    setGridSorts,
};

const mapStateToProps = state => ( 
    {  
        rowsDailyFiles: state.commodityReport.rowsDailyFiles,
        loading: state.commodityReport.loadingDailyFiles,
        lastUpdated: selectors.getDailyFilesLastUpdated(state),
        defaultSort: getDefaultSort(state),
    }
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewDailyFiles));
